import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import { routes } from '../../../index';

import List from './List';
import Review from './Review';

const mapStore = (store) => ({});

const mapDispatch = {};

const Memberships = (props) => (
  <Switch>
    <Route exact path={routes.admin.memberships.root} render={() => <List {...props} />} />
    <Route path={routes.admin.memberships.review} render={() => <Review {...props} />} />
  </Switch>
);

export default connect(mapStore, mapDispatch)(Memberships);
